import React, { ReactElement } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

interface CreateRouteProps<TProps = {}> {
	params: RouteProps;
	path: string | string[];
	component: ReactElement<TProps>;
}

export const CreateRoute = ({ params, path, component }: CreateRouteProps) => (
	<Route key={uuid()} {...params} path={path}>
		{component}
	</Route>
);
